"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = WebPage;

var _WebPage = require("@adobe/react-spectrum-workflow/dist/WebPage");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function WebPage(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_WebPage.A4uWebPage, null));
}